<div class="psc-card"
     [class.psc-card--expanded]="expanded"
     [class.psc-card--running]="runState?.status === 'running'"
     [class.psc-card--done]="runState?.status === 'completed'"
     [class.psc-card--failed]="runState?.status === 'failed'"
     [class.psc-card--skipped]="runState?.status === 'skipped'">

  <!-- Header (always visible) -->
  <div class="psc-card__header" (click)="expandToggle.emit()">
    <div class="psc-card__icon" [style.color]="step.color">
      <i class="fa-solid" [ngClass]="step.icon"></i>
    </div>
    <div class="psc-card__info">
      <div class="psc-card__name">{{ step.displayName }}</div>
      <div class="psc-card__status-row">
        <span class="psc-status-dot" [class]="'psc-status-dot--' + statusLabel"></span>
        <span class="psc-card__status-text">{{ statusLabel }}</span>
        <span class="psc-card__elapsed" *ngIf="elapsed">{{ elapsed }}</span>
      </div>
    </div>
    <div class="psc-card__actions">
      <button class="psc-icon-btn" (click)="remove.emit(); $event.stopPropagation()"
              title="Remove step" [disabled]="disabled">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>

  <!-- Expanded body -->
  <div class="psc-card__body" *ngIf="expanded">

    <!-- Description -->
    <div class="psc-card__desc" *ngIf="step.agentName">{{ step.agentName }}</div>

    <!-- Instructions -->
    <div class="psc-field">
      <label class="psc-field__label">Instructions</label>
      <textarea class="psc-field__textarea"
                [value]="step.instructions"
                (input)="onInstructionsInput($any($event.target).value)"
                [placeholder]="instructionsHint"
                rows="3"
                [disabled]="disabled"></textarea>
    </div>

    <!-- Template editor (conditional) -->
    <div class="psc-field" *ngIf="step.templateType">
      <div class="psc-field__label-row">
        <label class="psc-field__label">Template</label>
        <button class="psc-text-btn" (click)="toggleTemplateEditor()" [disabled]="disabled">
          <i class="fa-solid" [class.fa-pencil]="!showTemplateEditor" [class.fa-chevron-up]="showTemplateEditor"></i>
          {{ showTemplateEditor ? 'Close' : (matchingTemplate ? 'Edit' : 'No template') }}
        </button>
      </div>
      <div class="psc-template-info" *ngIf="!showTemplateEditor && matchingTemplate">
        <span class="psc-template-name">{{ matchingTemplate.Name || step.templateType }}</span>
      </div>
      <div class="psc-template-editor" *ngIf="showTemplateEditor && matchingTemplate">
        <textarea class="psc-field__textarea psc-field__textarea--code"
                  [(ngModel)]="editedTemplateBody"
                  rows="8"
                  [disabled]="disabled"></textarea>
        <div class="psc-template-actions">
          <button class="psc-btn psc-btn--sm psc-btn--primary" (click)="onTemplateSave()" [disabled]="disabled">
            <i class="fa-solid fa-check"></i> Save Template
          </button>
          <button class="psc-btn psc-btn--sm" (click)="showTemplateEditor = false">Cancel</button>
        </div>
      </div>
      <div class="psc-template-missing" *ngIf="showTemplateEditor && !matchingTemplate">
        No active template found for "{{ step.templateType }}". Create one in Settings &gt; Templates.
      </div>
    </div>

    <!-- Reorder buttons -->
    <div class="psc-reorder" *ngIf="totalSteps > 1">
      <button class="psc-icon-btn" (click)="moveUp.emit(); $event.stopPropagation()"
              [disabled]="stepIndex === 0 || disabled" title="Move left">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <span class="psc-reorder__label">Step {{ stepIndex + 1 }} of {{ totalSteps }}</span>
      <button class="psc-icon-btn" (click)="moveDown.emit(); $event.stopPropagation()"
              [disabled]="stepIndex === totalSteps - 1 || disabled" title="Move right">
        <i class="fa-solid fa-arrow-right"></i>
      </button>
    </div>
  </div>

  <!-- Run output summary -->
  <div class="psc-card__output" *ngIf="runState?.outputSummary">
    <i class="fa-solid fa-check" style="color: var(--mj-color-success-400)"></i>
    <span>{{ runState!.outputSummary }}</span>
  </div>

  <!-- Agent run ID (for debugging) -->
  <div class="psc-card__run-id" *ngIf="runState?.agentRunId">
    <span class="psc-card__run-id-label">Run:</span>
    <span class="psc-card__run-id-value">{{ runState!.agentRunId!.substring(0, 8) }}...</span>
  </div>

  <!-- Error display -->
  <div class="psc-card__error" *ngIf="runState?.error">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span class="psc-card__error-text">{{ runState!.error }}</span>
  </div>
</div>
